export const FOCUS_MODE_BACKGROUND_GRACE_PERIOD_MS = 30_000;
export const FOCUS_MODE_DEFAULT_BONUS_POINTS = 10;
export const FOCUS_MODE_STATUS_POLL_INTERVAL_MS = 60_000;
